//
(function() {
    //IDがheaderのオブジェクトを取得
    var header = document.querySelector("#headroom");
    //ｘｘｘｘｘｘｘを判定　←さっぱりわかりませんでした。。。。
    if(window.location.hash) {
        //haderオブジェクトに下記のクラスを追加
        header.classList.add("headroom--unpinned");
    }

    //headerオブジェクトの設定(アニメートの設定など)
    //tolerance=どれくらいスクロールしたらメニューの表示可否イベントを走らせるか
    //offset=最初にメニューを非表示にするページ上部からの位置
    var headroom = new Headroom(header, {
            tolerance: {
                down : 5,
                up : 10
            },
            offset : 180
    });
    //上記で設定した設定値の反映
    headroom.init();
}());
